<template>
  <v-container fluid>
    <v-data-iterator
      :items="items"
      :items-per-page.sync="itemsPerPage"
      :page="page"
      :search="search"
      :sort-by="sortBy.toLowerCase()"
      :sort-desc="sortDesc"
      hide-default-footer
      disable-pagination
    >
      <template v-slot:header>
        <v-toolbar class="mb-1">
          <v-text-field
            v-model="search"
            clearable
            flat
            solo-inverted
            hide-details
            prepend-inner-icon="mdi-search"
            label="Search"
          ></v-text-field>
        </v-toolbar>
      </template>

      <template v-slot:default="props">
        <!-- <template> -->
        <v-row>
          <!-- <v-col
              v-for="item in props.items"
              :key="item.RID"
              cols="12"
              sm="6"
              md="4"
              lg="3"
          >-->
          <v-col v-for="(item, i) in props.items" :key="i" cols="12">
            <v-card :color="item.Color">
              <!-- <div class="d-flex justify-space-between"> -->
              <div>
                <v-card-title class="subheading font-weight-bold">
                  {{ item.HappName }} .
                 
                    <v-icon v-if="item.RegIdInHapp > 0" small color="green"
                      >mdi-check-circle-outline</v-icon
                    >
                    <v-icon v-else small color="red"
                      >mdi-checkbox-blank-circle-outline</v-icon
                    >
                </v-card-title>
                <!-- <v-card-subtitle>Sub</v-card-subtitle> -->
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <!-- <v-row  class="d-flex justify-center">
                      <v-col> -->
                      <!-- <v-spacer></v-spacer> -->
                    <v-avatar size="24" right
                      ><img :src="item.FlagUrl"
                    /></v-avatar>
                    <v-spacer></v-spacer>
                    <v-label>{{ item.StartStringDate }}</v-label>
                    <v-label> --- </v-label>
                    <!-- <v-spacer></v-spacer> -->
                    <v-label>{{ item.EndStringDate }}</v-label>
                    <v-spacer></v-spacer>
                    
                    <v-avatar color="primary" size="24"
                      ><span class="white--text">{{
                        item.NumOfPilots
                      }}</span></v-avatar
                    >
                    <!-- <v-spacer></v-spacer> -->
                    <!-- <v-label>Sing-in Open: {{item.FirstRegDate}}</v-label>
                      <v-spacer></v-spacer> -->
                    <v-chip
                      color="primary"
                      dark
                      min-width="300"
                      rounded
                      small
                      :to="{ name: 'EventDetail', params: { id: item.HappId } }"
                      >Details
                      <v-icon right small>mdi-view-list-outline</v-icon></v-chip
                    >
                    <v-spacer></v-spacer>
                      <!-- </v-col>
                  </v-row> -->
                </v-card-actions>
                <!-- <v-card-text class="text-h6">{{item.Comment}}</v-card-text>
                  <v-card-subtitle
                    v-text="item.Action + ' on ' + item.Dato + ' ' + item.Tid + ' By ' + item.OpenedBy + ', Mobile: ' + item.OpenedByMID"
                  ></v-card-subtitle>
                  <v-card-actions><v-btn rounded small color="primary" :to="item.ToLsbLink" v-if="item.Ant>0">Participants - {{item.Ant}}</v-btn>
                  <v-btn rounded small color="primary" :to="item.ToMapBoxLink" v-if="item.AntPos>0">Map - {{item.AntPos}} </v-btn>
                  </v-card-actions> -->
              </div>
              <!-- <div>.</div> -->
              <!-- </div> -->
            </v-card>
          </v-col>
        </v-row>
      </template>

      <!-- <template v-slot:footer>
        <v-row class="mt-2" align="center" justify="center">
          <span class="grey--text">Items</span>
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn dark text color="primary" class="ml-2" v-on="on">
                {{ itemsPerPage }}
                <v-icon>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(number, index) in itemsPerPageArray"
                :key="index"
                @click="updateItemsPerPage(number)"
              >
                <v-list-item-title>{{ number }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-spacer></v-spacer>

          <span class="mr-4 grey--text"
            >Page {{ page }} of {{ numberOfPages }}</span
          >
          <v-btn
            small
            fab
            dark
            color="blue darken-3"
            class="mr-1"
            @click="formerPage"
          >
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn
            small
            fab
            dark
            color="blue darken-3"
            class="ml-1"
            @click="nextPage"
          >
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </v-row>
      </template> -->
    </v-data-iterator>
  </v-container>
</template>

<script>
// import axios from "axios";

export default {
  name: "EventCard",
  props: {
    items: {
      type: Array,
    },
    loading: Boolean,
  },
  data() {
    return {
      itemsPerPageArray: [1000, 2000, 4000, 10000],
      search: "",
      filter: {},
      sortDesc: false,
      page: 1,
      itemsPerPage: 1000,
      sortBy: "event",
      keys: ["Event", "EventDescription", "Status"],
      e1: 1,
      //   loading: true,
    };
  },
  computed: {
    numberOfPages() {
      return Math.ceil(this.items.length / this.itemsPerPage);
    },
    filteredKeys() {
      return this.keys.filter((key) => key !== `Name`);
    },
  },
  methods: {
    nextPage() {
      if (this.page + 1 <= this.numberOfPages) this.page += 1;
    },
    formerPage() {
      if (this.page - 1 >= 1) this.page -= 1;
    },
    updateItemsPerPage(number) {
      this.itemsPerPage = number;
    },
  },
};
</script>